/**
 * Continuous horizontal auto-scroll for Magio product rails.
 * Root: [data-magio-product-rail]
 */
(function () {
  function init(root) {
    if (!root || root.dataset.magioProductRailInit === '1') return;
    var track = root.querySelector('[data-magio-product-rail-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-magio-product-rail-slide]'));
    var count = originals.length;
    if (count < 2) return;

    root.dataset.magioProductRailInit = '1';

    originals.forEach(function (slide) {
      track.appendChild(slide.cloneNode(true));
    });

    var offset = 0;
    var lastTs = 0;
    var running = true;
    var secPerSlide = window.MagioAutoscroll
      ? MagioAutoscroll.clampSeconds(root.dataset.secondsPerSlide)
      : 12;
    var pauseHover = root.dataset.pauseHover === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rafId = 0;

    function gapPx() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function slideWidth() {
      var first = track.querySelector('[data-magio-product-rail-slide]');
      return first ? first.offsetWidth : 0;
    }

    function stepWidth() {
      return slideWidth() + gapPx();
    }

    function cycleWidth() {
      return stepWidth() * count;
    }

    function pixelsPerSecond() {
      return window.MagioAutoscroll
        ? MagioAutoscroll.pixelsPerSecond(slideWidth(), secPerSlide)
        : 0;
    }

    function wrapOffset() {
      var cw = cycleWidth();
      if (cw <= 0) return;
      while (offset <= -cw) offset += cw;
      while (offset > 0) offset -= cw;
    }

    function setTransform() {
      wrapOffset();
      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }

    function tick(ts) {
      if (!running || reduceMotion) return;
      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      offset -= pixelsPerSecond() * dt;
      setTransform();
      rafId = window.requestAnimationFrame(tick);
    }

    function start() {
      if (reduceMotion || rafId) return;
      rafId = window.requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
    }

    if (reduceMotion) {
      track.style.transform = 'none';
      return;
    }

    if (pauseHover) {
      root.addEventListener('mouseenter', function () {
        running = false;
        stop();
      });
      root.addEventListener('mouseleave', function () {
        running = true;
        lastTs = 0;
        start();
      });
    }

    window.addEventListener('resize', setTransform);
    setTransform();
    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-magio-product-rail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
